import { render } from "./ResourceLoader.vue?vue&type=template&id=03757142&ts=true"
import script from "./ResourceLoader.vue?vue&type=script&lang=ts"
export * from "./ResourceLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__